import React from 'react';
import FormHookInput from "../../air/airBooking/components/formHookInput";
import {useController} from "react-hook-form";
import _ from "lodash";
import ApiSelect from "../../base/components/forms/apiSelect";

const MileCardsInputs = ({formController, prefix, item}) => {
  const {
    formState:{errors},
    getValues,
    register,
    control,
    watch} = formController
  const {
    field: { onChange: airlineOnChange, value: airlineValue }
  } = useController({
    name: `${prefix}airline`,
    control,
    rules: { required: true },
  });
  return (
    <div style={{width:'100%'}}>
      <div className={'d-flex align-items-center gap-2 mb-3'}>
        <div style={{width:'50%'}}>
          <ApiSelect
            value={airlineValue}
            minFindLength={1}
            label={'Airline'}
            hasError={_.get(errors, `${prefix}airline`)}
            url={"/api/air/airlines/searchInput"}
            cb={newVal => airlineOnChange(newVal)}
          />
        </div>

        <FormHookInput
          register={register(`${prefix}number`, {required: true})}
          label={'№ Карты'}
          style={{width:'50%'}}
          errors={errors}
        />
      </div>
      <FormHookInput
        register={register(`${prefix}description`)}
        label={'Комментарий'}
        errors={errors}
      />
    </div>
  );
};

export default MileCardsInputs;
